export const orderListConstants = Object.freeze({
  NO_SHIPMENTS_ASSIGNED: 'There are no shipments associated with this order yet.',
})
